import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router'

import { type SecondaryNavGroupItem } from './'
import styles from './Links.module.css'

interface LinksProps {
  can: (permission: string) => boolean
  forceRefresh?: boolean
  links: SecondaryNavGroupItem[]
  navExpanded?: boolean
  orgId?: string
  siteId?: string
  teamId?: string
  uuid?: string
  shareToken?: string
}

export const Links = ({ can, links, orgId, siteId, teamId, uuid, shareToken }: LinksProps): JSX.Element => {
  const filteredLinks = links.filter(({ permission }) => (permission ? can(permission) : true))

  return (
    <ul className={styles.navList} role="menu" aria-label="Navigation submenu">
      {filteredLinks.map(({ labelId, to }) => (
        <li key={labelId} className={styles.navListItem} role="none">
          <NavLink to={to({ orgId, siteId, teamId, uuid, shareToken })} role="menuitem">
            <FormattedMessage id={labelId} />
          </NavLink>
        </li>
      ))}
    </ul>
  )
}
